export function filterNum(number) {
    let decimals = 3
    let dec_point = '.'
    let thousands_sep = ','

    number = (number + '').replace(/[^0-9+-Ee.]/g, '')
    if( number!=='ee'){
        number = Number(number)
        number = number.toFixed(3)
    }
    let n = !isFinite(+number) ? 0 : +number
    let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    let sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep
    let dec = (typeof dec_point === 'undefined') ? '.' : dec_point
    let s = ''
    let toFixedFix = function (n, prec) {
        let k = Math.pow(10, prec)
        return '' + Math.ceil(n * k) / k
    }

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    var re = /(-?\d+)(\d{3})/
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2")
    }

    if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    // if (s[1] === "999") {
    //     s[0] = Number(s[0]) + 1
    //     s[0] = s[0] + ''
    //     s[1] = "000"
    // }
    if(s[0] === "0" && s[1] === "000") {
        return "0"
    } else {
        return s.join(dec)
    }
}

export function filterZero(val) {
    if (val == 0.00) {
        return 0
    } else {
        val = val + ''
        if (val.indexOf('.00') !== -1) {
            val = val.substring(0, val.indexOf('.00'))
            return val
        } else {
            return val
        }
    }
}

export function formatterMoney(val) {
    if (val) {
        val = Number(val)
        val = val.toFixed(2)
        let isMin = false
        val = val.toString()
        if (val.indexOf('-') > -1) {
            isMin = true
            val = val.split('-').join('')
        }
        val = val.replace(/^(\d*)$/, '$1.')
        val = (val + '00').replace(/(\d*\.\d\d)\d*/, '$1')
        val = val.replace('.', ',')
        var re = /(\d)(\d{3},)/
        while (re.test(val)) {
            val = val.replace(re, '$1,$2')
        }
        val = val.replace(/,(\d\d)$/, '.$1')
        return isMin ? '-' + val.replace(/^\./, '0.') : val.replace(/^\./, '0.')
    } else {
        return 0
    }
}

export function filterDate(date) {
    date.length
}



// WEBPACK FOOTER //
// ./src/utils/filter.js